import { FC, useEffect } from "react";
import { Box, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import { useKeycloak } from "@Contexts/KeycloakContext";
import { Button } from "@Components/Button";
import { usePageTitle } from "@Hooks/usePageTitle";

export const KeycloakLogin: FC = () => {
  usePageTitle("Entrar");
  const { login, isLoading, isAuthenticated } = useKeycloak();

  useEffect(() => {
    if (isAuthenticated) {
      window.location.href = "/";
    }
  }, [isAuthenticated]);

  return (
    <Flex minH="100vh" align="center" justify="center" bg="primary.light.base">
      <Box
        bg="neutrals.surface.surface-0"
        borderRadius="16px"
        p="40px"
        w="100%"
        maxW="400px"
        boxShadow="0 8px 32px rgba(0,0,0,0.12)"
      >
        <VStack spacing={6} align="stretch">
          <Box textAlign="center">
            <Heading
              as="h1"
              fontSize="24px"
              fontFamily="heading"
              color="primary.light.base"
              letterSpacing="-0.02em"
            >
              Rede Frota — Mapa de Rota
            </Heading>
            <Text
              mt="8px"
              fontSize="sm"
              color="neutrals.text.sub-600"
              fontFamily="body"
            >
              Ferramenta interna do time comercial — mapa de rotas de prospects e
              avaliação de clientes. Entre com sua conta Rede Frota para continuar.
            </Text>
          </Box>

          <Button
            colorSchema="brand"
            onClick={() => login()}
            isLoading={isLoading}
            loadingText="Redirecionando..."
            fullWidth
            h="48px"
            fontSize="16px"
            fontWeight="600"
          >
            Entrar
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
};
